import { reactive, toRefs, watch } from "vue";
import apis from "@/api";
export default {
  name: "SensitiveWordsDialog",
  props: {
    assetsIds: {
      type: Array
    }
  },
  setup(props, context) {
    const data = reactive({
      visible: false,
      sensWordsList: []
    });
    const close = () => {
      data.visible = true;
    };
    const showSensitiveWords = () => {
      data.visible = true;
    };
    watch(() => props.assetsIds, (val, oldVal) => {
      const aids = val.join(',');
      apis.getSensWordByAssetsIds({
        aids
      }).then(res => {
        if (res.code == 200) {
          data.sensWordsList = res.data;
        }
        console.log(data.sensWordsList);
      });
    });
    return {
      ...toRefs(data),
      close,
      showSensitiveWords
    };
  }
};